import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  ansokanUrl: sharedEnvironment.utv.ansokanUrl,
  bpUrl: sharedEnvironment.utv.bpUrl,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  ansokanApiUrl: `${sharedEnvironment.utv.gatewayUrl}/ansok`,
  ansokanSignalRUrl: `${sharedEnvironment.utv.gatewayUrl}/ansok`,
  etjansterCommonApiUrl: `${sharedEnvironment.utv.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/ansokan`,
  sprakHanteringApiUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.utv.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.utv.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.utv.projektUrl,
  chatbotApiUrl: `${sharedEnvironment.utv.gatewayUrl}/ansok/chatbot`,
  externalLinks: sharedEnvironment.utv.externalLinks,
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.utv.gatewayUrl}/ansok`,
      sharedEnvironment.utv.azureAdB2C.clientId.ansokanClientId,
      sharedEnvironment.utv.azureAdB2C.clientId.ansokanApiClientId,
    ),
    authority: sharedEnvironment.utv.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.utv.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.utv.azureAdB2C.clientId.ansokanApiClientId}/all`,
    tenant: sharedEnvironment.utv.azureAdB2C.tenant,
    policies: sharedEnvironment.utv.azureAdB2C.policies,
    clientId: sharedEnvironment.utv.azureAdB2C.clientId,
  },
  ga4MeasurementId: sharedEnvironment.utv.ga4MeasurementId,
};
